import { z } from "zod";
import { getJsonSync } from "./lib/utils";

const EnvironmentSchema = z.object({
  mode: z.enum(["production", "development", "qa"]).default("development"),
  auth: z.object({
    authority: z.string().url(),
    clientId: z.string(),
    responseType: z.string(),
    scope: z.string(),
  }),
  api: z.object({
    baseUrl: z.string().url(),
  }),
});

const globalForEnv = globalThis as typeof globalThis & {
  env: z.infer<typeof EnvironmentSchema>;
};

export const env =
  globalForEnv.env ??
  EnvironmentSchema.parse({
    mode: import.meta.env.MODE,
    ...getJsonSync("/env.json"),
  });

if (env.mode === "production") {
  globalForEnv.env = env;
}
